import storeManager from '../../store/StoreManager';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import { setMarkerPosition } from '../../actions/AudioEditorActions';
import playController from './PlayController';
import exporterUtils from './ExporterUtils';

const exportPlayerController = {
    time: [],
    trackWidth: 0,
    MARKER_STEP: 10, // miliseconds
    markerTimer: undefined,
    keyboardShortcutAction: undefined,
    startTime: -1,
    startDate: -1,

    loadData() {
        const state = storeManager.getState();
        var slides = state.production.slides;
        var isAudioEditor = playController.isAudioEditorAvailable();

        if (isAudioEditor)
            slides = exporterUtils.checkSlides(slides);

        for (var i=0; i<slides.length; i++)
            this.time.push(slides[i].time);
    },
    getVideoCurrentTime() {
        var video = document.getElementById('exportedVideo');

        if (!video)
            return 0;

        return video.currentTime;
    },
    getVideoTotalTime() {
        var video = document.getElementById('exportedVideo');

        if (!video)
            return 0;

        return video.duration;
    },
    isPlaying() {
        var video = document.getElementById('exportedVideo');

        if (!video)
            return false;

        if (video.paused)
            return false;
        else
            return true;
    },
    getTotalTime(addMilliseconds = true) {
        return audioToolUtils.getCurrentTime(this.getVideoTotalTime(), addMilliseconds);
    },
    getCurrentTime(addMilliseconds = true) {
        return audioToolUtils.getCurrentTime(this.getVideoCurrentTime(), addMilliseconds);
    },
    getMarkerPosition() {
        return (this.trackWidth * this.getVideoCurrentTime()) / this.getVideoTotalTime();
    },
    getMarkerTime(markerPosition) {
        return (this.getVideoTotalTime() * markerPosition) /  this.trackWidth;
    },
    setVideoPosition(position) {
        var video = document.getElementById('exportedVideo');

        if (!video)
            return 0;

        video.currentTime = position;
    },
    getVolume() {
        const state = storeManager.getState();
        var volume = state.audioEditor.volume;

        if (volume == undefined)
            volume = 0.5;

        return volume;
    },
    updateVolume() {
        var video = document.getElementById('exportedVideo');

        if (video)
            video.volume = this.getVolume();
    },
    play(start = true) {
        var video = document.getElementById('exportedVideo');

        if (!video)
            return;

        if (start) {
            this.playMarker();
            video.volume = this.getVolume();
            video.play();
        } else {
            video.pause();
            this.clearTimer();
        }
    },
    playMarker() {
        this.clearTimer();
        this.startTime = this.getVideoCurrentTime();
        this.startDate = new Date().getTime();

        this.markerTimer = setInterval(this.checkMarkerPosition.bind(this), this.MARKER_STEP);
    },
    checkMarkerPosition() {
        const dispatch = this.getDispatch();
        var offset = (new Date().getTime() - this.startDate) / 1000;
        var newPos = this.startTime + offset;

        if (this.startTime < 0) {
            this.clearTimer();

            return;
        }

        dispatch(setMarkerPosition(newPos));
    },
    getDispatch() {
        const store = storeManager.getStore();
        return store.dispatch;
    },
    clearTimer() {
        if (this.markerTimer)
            clearInterval(this.markerTimer);

        this.startTime = -1;
    },
    getCurrentSlideIndex() {
        if (this.time.length == 1)
            return 0;

        var currentPosition = this.getVideoCurrentTime();
        var position = 0;
        var index = 0;

        if (currentPosition < 0.1)
            return 0;

        if (currentPosition >= this.getVideoTotalTime())
            return this.time.length - 1;

        for (var i=0; i<this.time.length; i++) {
            var nextPosition = position + this.time[i];

            if (currentPosition > position && currentPosition <= nextPosition) {
                index = i;
                break;
            }

            position = nextPosition;
        }

        if (index < 0)
            index = 0;

        if (index > this.time.length - 1)
            index = this.time.length - 1;

        return index;
    },
    getPreviousSlideTime() {
        var currentIndex = this.getCurrentSlideIndex();
        var nextIndex = currentIndex - 1;

        if (nextIndex <= 0)
            return 0;

        var time = 0;

        for (var i=0; i<nextIndex; i++){
            time = time + this.time[i];
        }

        var offset = 0.3;
        time = time + offset;

        return time;
    },
    getNextSlideTime(isEndAction = false) {
        var currentIndex = this.getCurrentSlideIndex();
        var nextIndex = currentIndex + 1;

        if (this.time.length < 2)
            return 0;

        if (nextIndex >= this.time.length || isEndAction)
            nextIndex = this.time.length - 1;

        var time = 0;

        for (var i=0; i<nextIndex; i++){
            time = time + this.time[i];
        }

        var offset = 0.3;
        time = time + offset;

        return time;
    },
    getSlidesText() {
        var index = this.getCurrentSlideIndex() + 1;

        if (index > this.time.length)
            index = this.time.length;

        return index + ' / ' + this.time.length;
    }
};

export default exportPlayerController;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ExportPlayerController.js
 **/